/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * OpenAPI definition
 * OpenAPI spec version: v0
 */

export type CampaignTouchpointSummaryDTOType =
  (typeof CampaignTouchpointSummaryDTOType)[keyof typeof CampaignTouchpointSummaryDTOType];

// eslint-disable-next-line @typescript-eslint/no-redeclare
export const CampaignTouchpointSummaryDTOType = {
  EMAIL: "EMAIL",
  LANDING_PAGE: "LANDING_PAGE",
  OTHER: "OTHER",
} as const;
